import { FC } from 'react'
import { Rating } from '@lifedot/atoms/Rating'
import { typography } from '@lifedot/styles/typography'
import { router } from '@lifedot/router'
import { css } from '@emotion/react'

interface ScoreProps {
  score: number
  count?: number
}

export const Score: FC<ScoreProps> = ({ score, count }) => {
  return (
    <>
      <Rating point={score} />
      {count && <span css={typography.textXS}>({count}件)</span>}
    </>
  )
}

const styles = {
  review: css({
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none'
  })
}

export interface ScoreWithLinkProps extends ScoreProps {
  cemeteryId: number
}

export const ScoreWithLink: FC<ScoreWithLinkProps> = ({
  score,
  count,
  cemeteryId
}) => {
  return (
    <a href={router.review(cemeteryId, count)} css={styles.review}>
      <Score score={score} count={count} />
    </a>
  )
}
